import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBannerMobile from '@wix/da-ds/pkg/PromoBannerMobile';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import {
  BiData,
  ViewSubscriptionTabBiEvent,
  BiContextProvidedValue,
} from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

export interface Props {
  className?: string;
}

const OfferSubscriptionsAdBanner: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isBannerAd2 = useFlag('ms_banner_ad_2');

  const messageKey = `browse.offerSubsAd.bannerText${isBannerAd2 ? '.2' : ''}`;
  const ctaLabelKey = `browse.offerSubsAd.linkText${isBannerAd2 ? '.2' : ''}`;

  if (isMobile) {
    return (
      <PromoBannerMobile
        className={className}
        message={t(messageKey)}
        ctaLabel={t(ctaLabelKey)}
        ctaHref={t('browse.offerSubsAd.linkURL')}
        ctaBiData={BiData<ViewSubscriptionTabBiEvent>({
          evid: 547,
          itemid: BiContextProvidedValue,
          typeid: BiContextProvidedValue,
          referral_info: ReferralType.HOMEPAGE_PROMOTION,
        })}
      />
    );
  }

  return (
    <PromoBanner
      className={className}
      size="big"
      variant="artist"
      icon={<PromoBadge badgeType="tier" size={24} />}
      messageAfterIcon={t(messageKey)}
      ctaLabel={t(ctaLabelKey)}
      ctaHref={t('browse.offerSubsAd.linkURL')}
      ctaBiData={BiData<ViewSubscriptionTabBiEvent>({
        evid: 547,
        itemid: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        referral_info: ReferralType.HOMEPAGE_PROMOTION,
      })}
    />
  );
};
OfferSubscriptionsAdBanner.displayName = 'OfferSubscriptionsAdBanner';

export default OfferSubscriptionsAdBanner;
